import { ApolloClient, InMemoryCache, createHttpLink, NormalizedCacheObject } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { SERVICE_NAME_HEADER, DEVICE_NAME_HEADER } from '@pkgtour-workspace/common/src/constants/header';
import { env } from '@/lib/env';

const isNode = typeof window === 'undefined';

export const APOLLO_STATE_PROP_NAME = '__APOLLO_STATE__';

export const getGraphqlUrl = () => {
  const graphqlPath = '/graphql';

  if (isNode && env('SERVER_SIDE_GRAPHQL_SERVER_URL')) {
    return `${env('SERVER_SIDE_GRAPHQL_SERVER_URL')}${graphqlPath}`;
  }

  if (env('GRAPHQL_SERVER_URL')) {
    return `${env('GRAPHQL_SERVER_URL')}${graphqlPath}`;
  }

  return graphqlPath;
};

interface GenerateApolloClientOptions {
  cookie?: string;
  deviceType?: string;
  nClientIp?: string;
  userAgent?: string;
  initialState?: NormalizedCacheObject;
}

export const generateApolloClient = ({
  cookie,
  deviceType,
  nClientIp,
  userAgent,
  initialState,
}: GenerateApolloClientOptions) => {
  const link = setContext((_, { headers: originHeaders, ...rest }) => {
    const headers = {
      ...originHeaders,
      cookie: isNode ? cookie : undefined,
      [SERVICE_NAME_HEADER]: 'vertical',
      [DEVICE_NAME_HEADER]: deviceType ?? '',
    };

    if (isNode && nClientIp) {
      headers['n-client-ip'] = nClientIp;
    }

    if (isNode && userAgent) {
      headers['User-Agent'] = userAgent;
    }

    return {
      headers,
      ...rest,
    };
  });

  const cache = new InMemoryCache({
    typePolicies: {
      CodeType: {
        keyFields: ['code'],
      },
    },
  });

  return new ApolloClient({
    cache: cache.restore(initialState ?? {}),
    link: link.concat(
      createHttpLink({
        uri: getGraphqlUrl(),
        fetchOptions: { keepalive: isNode },
        credentials: 'include',
      }),
    ),
    ssrMode: isNode,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-first',
      },
      query: {
        fetchPolicy: 'cache-first',
      },
    },
  });
};
